import { addPageAction } from "@/js/utils/new-relic";
import { trackEvent } from "@/js/helpers/tracking";
import { getCookie } from "@/js/utils/cookie";
import { persistData } from "@/js/utils/session-storage";

export const isCartHeavy = (monarchResponse, query) => {
  if (monarchResponse === true || query?.heavy === "cart") {
    document.body.setAttribute("data-cart-heavy", true);
    addPageAction("cartHeavyActive");

    // Fire Indicator Event
    const data = {
      elementType: "BUY FLOW",
      position: "CART HEAVY",
    };

    trackEvent({ action: "elementViewed", data });

    return true;
  }
};

export const isPhoneHeavy = (monarchResponse, query) => {
  if (
    monarchResponse === true ||
    query?.utm_stlnk === "PhoneHeavy" ||
    query?.heavy === "phone"
  ) {
    document.body.setAttribute("data-phone-heavy", true);
    addPageAction("phoneHeavyActive");

    // Fire Indicator Event
    const data = {
      elementType: "BUY FLOW",
      position: "PHONE HEAVY",
    };

    trackEvent({ action: "elementViewed", data });

    return true;
  }
};

export const isResumeQuote = (monarchResponse) => {
  if (monarchResponse !== true) return false;

  const quoteId = getCookie("quoteId");

  return quoteId && quoteId.length === 36;
};

export const updateOLVersion = (monarchResponse) => {
  if (typeof monarchResponse === "string") {
    persistData("olVersion", monarchResponse);
    return true;
  }

  persistData("olVersion", "v2");
  return false;
};
